export default {"src":"/bnb/_next/static/media/terra.c57cc8ef.svg","height":14,"width":14};